import React from 'react';
import { SealCheck, CheckCircle } from '@phosphor-icons/react';
import { useLevelVerified } from '../lib/levelVerified';

/**
 * Blue seal for members; green check for non-members whose level was verified
 * by a coach (level test). Renders nothing otherwise.
 *
 *   <MemberBadge user={participant} />            // tries `is_member` / `user_is_member`
 *   <MemberBadge isMember={true} size={14} />     // explicit
 */
const MemberBadge = ({ user, isMember, size = 14, className = '', title }) => {
  const verifiedIds = useLevelVerified();
  const member =
    typeof isMember === 'boolean'
      ? isMember
      : Boolean(user?.is_member ?? user?.user_is_member);
  if (member) {
    return (
      <SealCheck
        size={size}
        weight="fill"
        className={`text-sky-500 inline-block flex-shrink-0 ${className}`}
        title={title || 'Padelarena Member'}
        data-testid="member-badge"
        aria-label="Member"
      />
    );
  }
  const uid = user?.user_id || user?.id || user?.player_id;
  if (!uid || !verifiedIds.has(uid)) return null;
  return (
    <CheckCircle
      size={size}
      weight="fill"
      className={`text-[#22c55e] inline-block flex-shrink-0 ${className}`}
      title="Level verifiziert (Level-Test) / Level verified"
      data-testid="level-verified-badge"
      aria-label="Level verified"
    />
  );
};

export default MemberBadge;
